<template>
  <v-main>
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">支付渠道</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon color="black" @click="onCreate">
        <v-icon>{{ mdiPlus }}</v-icon>
      </v-btn>
    </v-app-bar>
    <v-list>
      <v-list-item class="channel" :key="channel.id" v-for="channel in channelList" @click="onItemClick(channel.id)">
        <v-list-item-title class="channel-info">
          <span class="channel-name">{{ channel.name }}</span>
          <span class="channel-note" v-if="channel.note">( {{ channel.note }} )</span>
          <span class="channel-type">{{ getPaymentChannelTypeName(channel.type) }}</span>
        </v-list-item-title>
        <v-icon>{{ mdiChevronRight }}</v-icon>
      </v-list-item>
    </v-list>
  </v-main>
</template>

<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { mdiArrowLeft, mdiPlus, mdiChevronRight } from '@mdi/js'
import { homeStore } from '@/store/home'
import { paymentChannelStore } from '@/store/paymentChannel'
import { getPaymentChannelTypeName } from '@/plugins/payment'

export default {
  name: 'PaymentChannelPage',
  components: { AppbarBackIcon },
  data() {
    return {
      mdiArrowLeft,
      mdiPlus,
      mdiChevronRight,
    }
  },
  computed: {
    channelList() {
      return paymentChannelStore.list
    },
  },
  async mounted() {
    await homeStore.doLoad()
  },
  methods: {
    getPaymentChannelTypeName,
    onCreate() {
      this.$router.push('/dash/payment-channel-detail')
    },
    onItemClick(channelId) {
      this.$router.push({
        path: '/dash/payment-channel-detail',
        query: { id: channelId },
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

.channel {
  .channel-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .channel-note {
    flex: 1;
    font-size: 14px;
    margin-left: 8px;
    margin-right: 8px;
    color: @antTextGrey;
  }
  .channel-type {
    font-size: 14px;
    color: @antTextGrey;
  }
}
</style>
